<template>
  <div id="drop-zone" class="form-group">
    <div v-show="$refs.upload && $refs.upload.dropActive" class="drop-active">
      <h3>Déposer les fichiers ici</h3>
    </div>
    <div id="drop-zone-texts">
      <div><i class="fa fa-upload fa-2x"></i></div>
      <div>Glisser-déposer des fichiers ici</div>
      <div>ou</div>
      <VueUploadComponent
        ref="upload"
        :custom-action="getFileUploadAction"
        :active="true"
        v-model="value"
        :extensions="allowedExtensions"
        :multiple="true"
        drop="#drop-zone"
        @input-file="inputFile"
        :headers="{'X-Token': authToken}"
      >
        <button class="btn btn-secondary">Choisir des fichiers à envoyer</button>
      </VueUploadComponent>
    </div>
  </div>
</template>

<style scoped>
  #drop-zone {
    border: 3px dashed gray;
    border-radius: 15px;
    position: relative;
    text-align: center;
    max-width: 40rem;
    margin-left: auto;
    margin-right: auto;
  }
  #drop-zone-texts {
    padding: 2rem;
  }
  #drop-zone-texts div {
    padding-bottom: 0.5rem;
  }
  .drop-active {
    /*display: none;*/
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    background: #000;
    opacity: 0.7;
    z-index: 1000;
  }
  .drop-active h3 {
    text-align: center;
    color: #fff;
    margin: 2rem;
  }
  #drop-zone:hover .drop-active {
    /*display: block;*/
  }
</style>

<script>
  import VueUploadComponent from "vue-upload-component";
  import { mapGetters } from "vuex";
  import { getRestEndpointForFile } from "@/components/SongEditForm";

  export default {
    components: {
      VueUploadComponent,
    },
    props: {
      modelValue: {
        type: Array
      },
      allowedExtensions: {
        type: Array,
        default: () => ['*']
      },
      fileBaseName: {
        type: String
      }
    },
    computed: {
      ...mapGetters(["authToken"]),
      value: {
        get() {
          return this.modelValue;
        },
        set(value) {
          this.$emit('update:modelValue', value);
        }
      }
    },
    methods: {
      inputFile(newFile, oldFile) {
        if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
          this.$refs.upload.active = true;
        }

        if (newFile.type == '' && newFile.name.split('.').pop() == 'chopro') {
          newFile.type = 'text/chopro';
        }

        if (newFile.error && (oldFile?.error != newFile.error)) {
          this.$emit('error', newFile);
        }

        if (newFile.success) {
          this.$emit('success', newFile);
        }
      },
      async getFileUploadAction(file, component) {
        file.putAction = getRestEndpointForFile(this.fileBaseName, file);
        return await component.uploadPut(file);
      }
    }
  }
</script>